module.exports = __webpack_public_path__ + "img/incein-circle-3.42966353.svg";